import AppointmentsComponents from '../Pages/AppointmentsPage';
import MassiveSMSComponents from '../Pages/MassiveMessages';
import PracticesPage from '../Pages/PracticesPage';
import UserManagementPage from '../Pages/UserManagement';
import SpotCampaignsPage from '../Pages/SpotCampaings/Components';
import AllCustomersPage from '../Pages/AllCustomers/Components';
import BirthdaysPage from '../Pages/Birthdays/Components';
import LightPage from '../Pages/Light/Components';
import PremiumBankPage from '../Pages/PremiumBank/Components';
import CorporatePage from '../Pages/Corporate/Components';
import EditorPage from '../Pages/Editor';
import SendsAnalysisPage from '../Pages/SendsAnalysis/Components';
import WelcomeCallsPage from '../Pages/WelcomeCalls';
import WaveManagementPage from '../Pages/WaveManagement';
import { ICONS } from '../Utils/constants/icons';
import PurchaseHistoryPage from '../Pages/PurchaseHistory';
import SettingsPage from '../Pages/SettingsPage';
import RoleManagementPage from '../Pages/RoleManagement';
import BranchManagementPage from '../Pages/BranchManagement';
import LeadsPage from '../Pages/LeadsManagement/Leads';
import LeadOriginPage from '../Pages/LeadsManagement/LeadOrigin';
import PivotReportPage from '../Pages/PivotReport/Outbound';
import InboundPivotReportPage from '../Pages/PivotReport/Inbound';
import CustomersCampaignsManagementPage from '../Pages/CustomersCampaignsManagement';
import KanbanPage from '../Pages/Kanban';
import FunnelReport from '../Pages/FunnelReport';
import ActivityProgressPage from '../Pages/ActivityProgressManagement';
import PrioritiesPage from '../Pages/PrioritiesPage';
import AppointmentsReportPage from '../Pages/AppointmentsReport';
import RedemptionReportPage from '../Pages/Redemption/RedemptionReport';
import RollingRedemptionReportPage from '../Pages/Redemption/RollingRedemptionReport';
import WaveActivitiesReportPage from '../Pages/WaveActivitiesReport';

export function checkFeature(featureName) {
  const { databeasy } = window || {};
  return (
    Object.hasOwn(databeasy, featureName) &&
    (databeasy[featureName] === 'true' ||
      databeasy[featureName] === 'True' ||
      databeasy[featureName] === true)
  );
}
const ROUTES_LONG_CHANNEL = [
  'REPORT',
  'APPOINTMENTSREPORT',
  'CUSTOMERS',
  'APPOINTMENT',
  'USER_MANAGEMENT',
  'ROLES_MANAGEMENT',
  'BRANCHES_MANAGEMENT',
  'WAVE_MANAGEMENT',
  'CONFIGURATIONS',
];

export const FULLPAGE_ROUTES = [
  'ROLLINGREDEMPTIONREPORT',
  'REDEMPTIONREPORT',
  'APPOINTMENTSREPORT',
  'FUNNELREPORT',
  'WAVEACTIVITIESREPORT',
  'OUTBOUNDCALLSANALYSIS',
  'INBOUNDCALLSANALYSIS',
];

const checkLongChannel = (isLongChannel, routeName, value) => {
  return isLongChannel ? ROUTES_LONG_CHANNEL.includes(routeName) : value;
};

export const ROUTES_COMPONENTS = {
  PRIORITIES: PrioritiesPage,
  ROLLINGREDEMPTIONREPORT: RollingRedemptionReportPage,
  REDEMPTIONREPORT: RedemptionReportPage,
  APPOINTMENTSREPORT: AppointmentsReportPage,
  FUNNELREPORT: FunnelReport,
  KANBAN: KanbanPage,
  WAVEACTIVITIESREPORT: WaveActivitiesReportPage,
  OUTBOUNDCALLSANALYSIS: PivotReportPage,
  INBOUNDCALLSANALYSIS: InboundPivotReportPage,
  CUSTOMERS: AllCustomersPage,
  LEADS: LeadsPage,
  LEAD_ORIGINS: LeadOriginPage,
  BIRTHDAYS: BirthdaysPage,
  LIGHT: LightPage,
  CORPORATE: CorporatePage,
  PREMIUMBANK: PremiumBankPage,
  PURCHASEHISTORY: PurchaseHistoryPage,
  SETTINGS: SettingsPage,
  SPOT: SpotCampaignsPage,
  ...(checkFeature('WELCOME_FEATURES') ? { WELCOME: WelcomeCallsPage } : {}),
  APPOINTMENT: AppointmentsComponents,
  ...(checkFeature('MASSIVE_FEATURES')
    ? { EDITOR: EditorPage, SENDS_ANALYSIS: SendsAnalysisPage } //TODO: enable editor when ready
    : {}),
  MASSIVE_SENDING: MassiveSMSComponents,
  ...(checkFeature('PRACTICES_FEATURES') ? { PRACTICES: PracticesPage } : {}),
  USER_MANAGEMENT: UserManagementPage,
  ROLES_MANAGEMENT: RoleManagementPage,
  BRANCHES_MANAGEMENT: BranchManagementPage,
  WAVE_MANAGEMENT: WaveManagementPage,
  CUSTOMERS_CAMPAIGNS_MANAGEMENT: CustomersCampaignsManagementPage,
  ACTIVITYPROGRESS_MANAGEMENT: ActivityProgressPage,
};

/**ROUTES constants**/
//all CRM's routes after login
export const APP_ROUTES = {
  PRIORITIES: '/priorities',
  ROLLINGREDEMPTIONREPORT: '/rollingRedemptionReport',
  REDEMPTIONREPORT: '/redemptionReport',
  APPOINTMENTSREPORT: '/appointmentsReport',
  FUNNELREPORT: '/funnelReport',
  KANBAN: '/kanban',
  ACTIVITYDASHBOARD: '/callsReport',
  OUTBOUNDCALLSANALYSIS: '/outboundPivotReport',
  INBOUNDCALLSANALYSIS: '/inboundPivotReport',
  CUSTOMERS: '/allContactsPage',
  LEADS: '/leadsPage',
  LEAD_ORIGINS: '/leadOriginPage',
  BIRTHDAYS: '/birthdaysPage',
  LIGHT: '/lightPage',
  CORPORATE: '/corporate',
  PREMIUMBANK: '/premiumBank',
  PURCHASEHISTORY: '/purchaseHistoryPage',
  SETTINGS: '/settingsPage',
  SPOT: '/spotCampaigns',
  ...(checkFeature('WELCOME_FEATURES') ? { WELCOME: '/welcomeCalls' } : {}),
  APPOINTMENT: '/recalls-appointments',
  MASSIVE_SENDING: '/massiveSending',
  ...(checkFeature('MASSIVE_FEATURES')
    ? { SENDS_ANALYSIS: '/sendsAnalysis', EDITOR: '/editor' }
    : {}),
  ...(checkFeature('PRACTICES_FEATURES') ? { PRACTICES: '/practices' } : {}),
  USER_MANAGEMENT: '/userManagement',
  ROLES_MANAGEMENT: '/roleManagement',
  BRANCHES_MANAGEMENT: '/branchManagement',
  WAVE_MANAGEMENT: '/waveManagement',
  CUSTOMERS_CAMPAIGNS_MANAGEMENT: '/customersCampaignsManagement',
  ACTIVITYPROGRESS_MANAGEMENT: '/activityProgressManagement',
  WAVEACTIVITIESREPORT: '/waveActivitiesReport',
};

export const ROUTES_TREE = {
  REPORT: {
    id: 'report',
    defaultOpen: true,
    visible: (isLongChannel) => checkLongChannel(isLongChannel, 'REPORT', true),
    subRoutes: {
      WAVEACTIVITIESREPORT: {
        id: 'waveActivitiesReport',
        visible: (isLongChannel) =>
          checkLongChannel(isLongChannel, 'WAVEACTIVITIESREPORT', true),
        subRoutes: null,
      },
      OUTBOUNDCALLSANALYSIS: {
        id: 'pivotReport',
        visible: (isLongChannel) =>
          checkLongChannel(isLongChannel, 'CALLSANALYSIS', true),
        subRoutes: null,
      },
      INBOUNDCALLSANALYSIS: {
        id: 'inboundPivotReport',
        visible: (isLongChannel) =>
          checkLongChannel(isLongChannel, 'INBOUNDCALLSANALYSIS', true),
        subRoutes: null,
      },
      REDEMPTION: {
        id: 'redemption',
        defaultOpen: true,
        visible: (isLongChannel) =>
          checkLongChannel(isLongChannel, 'REDEMPTIONREPORT', true),
        subRoutes: {
          REDEMPTIONREPORT: {
            id: 'redemptionReport',
            visible: (isLongChannel) =>
              checkLongChannel(isLongChannel, 'REDEMPTIONREPORT', true),
            subRoutes: null,
          },
          ROLLINGREDEMPTIONREPORT: {
            id: 'rollingRedemptionReport',
            visible: (isLongChannel) =>
              checkLongChannel(isLongChannel, 'ROLLINGREDEMPTIONREPORT', true),
            subRoutes: null,
          },
        },
      },
      FUNNELREPORT: {
        id: 'funnelReport',
        visible: (isLongChannel) =>
          checkLongChannel(
            isLongChannel,
            'FUNNELREPORT',
            checkFeature('CUSTOMER_CAMPAIGNS_FEATURE')
          ),
        subRoutes: null,
      },
      APPOINTMENTSREPORT: {
        id: 'appointmentsReport',
        visible: (isLongChannel) =>
          checkLongChannel(isLongChannel, 'APPOINTMENTSREPORT', false),
        subRoutes: null,
      },
    },
  },
  PRIORITIES: {
    id: 'priorities',
    visible: (isLongChannel) =>
      checkLongChannel(isLongChannel, 'PRIORITIES', true),
    subRoutes: null,
  },
  CUSTOMERS: {
    id: 'customers',
    visible: (isLongChannel) =>
      checkLongChannel(isLongChannel, 'CUSTOMERS', true),
    subRoutes: null,
  },
  LEADS_MANAGEMENT: {
    id: 'leads_management',
    visible: (isLongChannel) =>
      checkLongChannel(isLongChannel, 'LEADS_MANAGEMENT', true),
    subRoutes: {
      LEADS: {
        id: 'leads',
        visible: (isLongChannel) =>
          checkLongChannel(isLongChannel, 'LEADS', true),
        subRoutes: null,
      },
      LEAD_ORIGINS: {
        id: 'lead_origin',
        visible: (isLongChannel) =>
          checkLongChannel(isLongChannel, 'LEAD_ORIGINS', true),
        subRoutes: null,
      },
    },
  },
  BIRTHDAYS: {
    id: 'birthdays',
    visible: (isLongChannel) =>
      checkLongChannel(isLongChannel, 'BIRTHDAYS', true),
    subRoutes: null,
  },
  WAVE: {
    id: 'wave',
    defaultOpen: true,
    visible: (isLongChannel) => checkLongChannel(isLongChannel, 'WAVE', true),
    subRoutes: {
      LIGHT: {
        id: 'light',
        visible: (isLongChannel) =>
          checkLongChannel(isLongChannel, 'LIGHT', true),
        subRoutes: null,
      },
      PREMIUMBANK: {
        id: 'premium',
        visible: (isLongChannel) =>
          checkLongChannel(isLongChannel, 'PREMIUMBANK', true),
        subRoutes: null,
      },
      CORPORATE: {
        id: 'corporate',
        visible: (isLongChannel) =>
          checkLongChannel(isLongChannel, 'CORPORATE', true),
        subRoutes: null,
      },
      SPOT: {
        id: 'spot',
        visible: (isLongChannel) =>
          checkLongChannel(isLongChannel, 'SPOT', true),
        subRoutes: null,
      },
      WELCOME: {
        id: 'welcome',
        visible: (isLongChannel) =>
          checkLongChannel(
            isLongChannel,
            'WELCOME',
            checkFeature('WELCOME_FEATURES')
          ),
        subRoutes: null,
      },
    },
  },
  KANBAN: {
    id: 'kanban',
    visible: (isLongChannel) =>
      checkLongChannel(
        isLongChannel,
        'KANBAN',
        checkFeature('CUSTOMER_CAMPAIGNS_FEATURE')
      ),
    subRoutes: null,
  },
  CAMPAIGNS_MANAGEMENT: {
    id: 'campaigns',
    defaultOpen: true,
    visible: (isLongChannel) =>
      checkLongChannel(
        isLongChannel,
        'CAMPAIGNS_MANAGEMENT',
        checkFeature('MASSIVE_FEATURES')
      ),
    subRoutes: {
      MASSIVE_SENDING: {
        id: 'massive_sending',
        visible: (isLongChannel) =>
          checkLongChannel(isLongChannel, 'MASSIVE_SENDING', true),
        subRoutes: null,
      },
      SENDS_ANALYSIS: {
        id: 'sends_analysis',
        visible: (isLongChannel) =>
          checkLongChannel(
            isLongChannel,
            'SENDS_ANALYSIS',
            checkFeature('MASSIVE_FEATURES')
          ),
        subRoutes: null,
      },
      EDITOR: {
        id: 'editor',
        visible: (isLongChannel) =>
          checkLongChannel(
            isLongChannel,
            'EDITOR',
            checkFeature('MASSIVE_FEATURES')
          ),
        subRoutes: null,
      },
    },
  },
  MASSIVE_SENDING: {
    id: 'massive_sending',
    visible: (isLongChannel) =>
      checkLongChannel(
        isLongChannel,
        'MASSIVE_SENDING',
        !checkFeature('MASSIVE_FEATURES')
      ),
    subRoutes: null,
  },
  APPOINTMENT: {
    id: 'appointments',
    visible: (isLongChannel) =>
      checkLongChannel(isLongChannel, 'APPOINTMENT', true),
    subRoutes: null,
  },
  PRACTICES: {
    id: 'practices',
    visible: (isLongChannel) =>
      checkLongChannel(
        isLongChannel,
        'PRACTICES',
        checkFeature('PRACTICES_FEATURES')
      ),
    subRoutes: null,
  },

  CONFIGURATIONS: {
    id: 'settings',
    visible: (isLongChannel) =>
      checkLongChannel(isLongChannel, 'CONFIGURATIONS', true),
    subRoutes: {
      USER_MANAGEMENT: {
        id: 'users_management',
        visible: (isLongChannel) =>
          checkLongChannel(isLongChannel, 'USER_MANAGEMENT', true),
        subRoutes: null,
      },
      ROLES_MANAGEMENT: {
        id: 'roles_management',
        visible: (isLongChannel) =>
          checkLongChannel(isLongChannel, 'ROLES_MANAGEMENT', true),
        subRoutes: null,
      },
      BRANCHES_MANAGEMENT: {
        id: 'branches_management',
        visible: (isLongChannel) =>
          checkLongChannel(isLongChannel, 'BRANCHES_MANAGEMENT', true),
        subRoutes: null,
      },
      WAVE_MANAGEMENT: {
        id: 'waves',
        visible: (isLongChannel) =>
          checkLongChannel(isLongChannel, 'WAVE_MANAGEMENT', true),
        subRoutes: null,
      },
      CUSTOMERS_CAMPAIGNS_MANAGEMENT: {
        id: 'customers_campaigns_management',
        visible: (isLongChannel) =>
          checkLongChannel(
            isLongChannel,
            'CUSTOMERS_CAMPAIGNS_MANAGEMENT',
            checkFeature('CUSTOMER_CAMPAIGNS_FEATURE')
          ),
      },
      ACTIVITYPROGRESS_MANAGEMENT: {
        id: 'activity_progress',
        visible: (isLongChannel) =>
          checkLongChannel(isLongChannel, 'ACTIVITYPROGRESS_MANAGEMENT', true),
        subRoutes: null,
      },
    },
  },
};

//sections permissions by user roles
export const ROUTES_PERMISSIONS = {
  PRIORITIES: ['ADMIN', 'SUPERADMIN', 'SUPERVISOR', 'OPERATOR'],
  REDEMPTION: [
    'ADMIN',
    'SUPERADMIN',
    'SUPERVISOR',
    'OPERATOR',
    'LIMITEDOPERATOR',
  ],
  REDEMPTIONREPORT: ['ADMIN', 'SUPERADMIN', 'SUPERVISOR', 'LIMITEDOPERATOR'],
  ROLLINGREDEMPTIONREPORT: [
    'ADMIN',
    'SUPERADMIN',
    'SUPERVISOR',
    'OPERATOR',
    'LIMITEDOPERATOR',
  ],
  APPOINTMENTSREPORT: ['SUPERVISOR', 'ADMIN', 'SUPERADMIN'],
  FUNNELREPORT: ['SUPERVISOR', 'ADMIN', 'SUPERADMIN'],
  KANBAN: ['SUPERVISOR', 'ADMIN', 'SUPERADMIN'],
  REPORT: ['SUPERVISOR', 'OPERATOR', 'ADMIN', 'SUPERADMIN', 'LIMITEDOPERATOR'],
  WAVEACTIVITIESREPORT: ['SUPERVISOR', 'ADMIN', 'SUPERADMIN'],
  OUTBOUNDCALLSANALYSIS: [
    'ADMIN',
    'SUPERADMIN',
    'SUPERVISOR',
    'OPERATOR',
    'LIMITEDOPERATOR',
  ],
  INBOUNDCALLSANALYSIS: [
    'ADMIN',
    'SUPERADMIN',
    'SUPERVISOR',
    'OPERATOR',
    'LIMITEDOPERATOR',
  ],
  CUSTOMERS: [
    'SUPERVISOR',
    'OPERATOR',
    'ADMIN',
    'SUPERADMIN',
    'LIMITEDOPERATOR',
  ],
  LEADS_MANAGEMENT: ['ADMIN', 'SUPERADMIN'],
  LEADS: ['ADMIN', 'SUPERADMIN'],
  LEAD_ORIGINS: ['ADMIN', 'SUPERADMIN'],
  BIRTHDAYS: [
    'SUPERVISOR',
    'OPERATOR',
    'ADMIN',
    'SUPERADMIN',
    'LIMITEDOPERATOR',
  ],
  WAVE: [
    'SUPERVISOR',
    'OPERATOR',
    'ADMIN',
    'SUPERADMIN',
    'OPERATORHUB',
    'LIMITEDOPERATOR',
  ],
  LIGHT: ['SUPERVISOR', 'OPERATOR', 'ADMIN', 'SUPERADMIN', 'LIMITEDOPERATOR'],
  CORPORATE: [
    'SUPERVISOR',
    'OPERATOR',
    'ADMIN',
    'SUPERADMIN',
    'LIMITEDOPERATOR',
  ],
  PREMIUMBANK: [
    'SUPERVISOR',
    'OPERATOR',
    'ADMIN',
    'SUPERADMIN',
    'LIMITEDOPERATOR',
  ],
  SPOT: ['SUPERVISOR', 'OPERATOR', 'ADMIN', 'SUPERADMIN', 'LIMITEDOPERATOR'],
  WELCOME: ['SUPERVISOR', 'OPERATORHUB', 'ADMIN', 'SUPERADMIN'],
  APPOINTMENT: [
    'SUPERVISOR',
    'OPERATOR',
    'ADMIN',
    'SUPERADMIN',
    'LIMITEDOPERATOR',
  ],
  CAMPAIGNS_MANAGEMENT: ['SUPERVISOR', 'ADMIN', 'SUPERADMIN'],
  TEMPLATE_MESSAGES: ['ADMIN', 'SUPERADMIN'],
  MASSIVE_SENDING: ['SUPERVISOR', 'ADMIN', 'SUPERADMIN'],
  SENDS_ANALYSIS: ['SUPERVISOR', 'ADMIN', 'SUPERADMIN'],
  EDITOR: ['SUPERVISOR', 'ADMIN', 'SUPERADMIN'],
  PRACTICES: ['SUPERVISOR', 'OPERATOR', 'ADMIN', 'SUPERADMIN', 'OPERATORHUB'],
  USER_MANAGEMENT: ['ADMIN', 'SUPERADMIN'],
  ROLES_MANAGEMENT: ['ADMIN', 'SUPERADMIN'],
  BRANCHES_MANAGEMENT: ['SUPERADMIN'],
  WAVE_MANAGEMENT: ['ADMIN', 'SUPERADMIN', 'SUPERVISOR'],
  CONFIGURATIONS: ['ADMIN', 'SUPERADMIN', 'SUPERVISOR'],
  PURCHASEHISTORY: ['ACCOUNTING', 'ADMIN', 'SUPERADMIN'],
  SETTINGS: ['SUPERADMIN'],
  CUSTOMERS_CAMPAIGNS_MANAGEMENT: ['ADMIN', 'SUPERADMIN'],
  ACTIVITYPROGRESS_MANAGEMENT: ['ADMIN', 'SUPERADMIN'],
};

export const renderRoutesTree = (
  routesTree,
  isLongChannel,
  userRoles,
  flat = false
) => {
  const visibleRoutes = Object.keys(routesTree).filter((routeName) =>
    routesTree[routeName]?.visible(isLongChannel)
  );

  if (!flat) {
    return visibleRoutes;
  }

  // If flat is true, exclude parent routes with subroutes and render only their subroutes
  const flattenSubroutes = (subRoutes) => {
    return Object.keys(subRoutes).flatMap((subRouteName) => {
      const subRoute = subRoutes[subRouteName];
      if (!subRoute?.visible(isLongChannel)) return [];
      // Check if subroute is available for user
      const isSubRouteAvailableForUser = Boolean(
        userRoles?.find(({ roleId }) =>
          ROUTES_PERMISSIONS[subRouteName]?.find(
            (permission) => permission?.toUpperCase() === roleId?.toUpperCase()
          )
        )
      );
      if (!isSubRouteAvailableForUser) return [];

      // If subroute has nested subroutes, flatten them too
      if (subRoute.subRoutes && Object.keys(subRoute.subRoutes).length > 0) {
        return flattenSubroutes(subRoute.subRoutes);
      }
      return [subRouteName];
    });
  };

  return visibleRoutes.flatMap((routeName) => {
    const isRouteAvailableForUser = Boolean(
      userRoles?.find(({ roleId }) =>
        ROUTES_PERMISSIONS[routeName]?.find(
          (permission) => permission?.toUpperCase() === roleId?.toUpperCase()
        )
      )
    );
    if (!isRouteAvailableForUser) return [];
    const route = routesTree[routeName];
    if (route.subRoutes && Object.keys(route.subRoutes).length > 0) {
      // Recursively flatten all nested subroutes
      return flattenSubroutes(route.subRoutes);
    }
    // Return as is if no subroutes
    return [routeName];
  });
};
//to prevent dependency cycle
export const ROUTE_ICONS = { ...ICONS };
/****/
